import React, { useEffect, useState, useRef } from 'react';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { Autocomplete, TextField, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, Grid, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Checkbox } from "@mui/material";
import { Add as AddIcon, Delete as DeleteIcon, NavigateNext as NavigateNextIcon, KeyboardArrowLeft as KeyboardArrowLeftIcon } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomAutocomplete from '../../../Components/AutoComplete/AutoComplete';
import CrudButtons from '../../../GlobalFunction/CrudButtons';
import { useReactToPrint } from 'react-to-print';
import axiosInstance from '../../../lib/axios';
import moment from 'moment';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { enGB } from 'date-fns/locale';
import { format, isValid } from 'date-fns';
import checkAndLock from '../../../GlobalFunction/checkAndLock';
import PrintBarcode from './PrintBarcode';
import PrintIcon from '@mui/icons-material/Print';
import AssetDocumentPrint from './AssetDocumentPrint';

// Custom styled TextField component for consistent styling
const CustomTextField = styled(TextField)(({ theme }) => ({
    '& .MuiFilledInput-root': {
        backgroundColor: 'transparent',
        border: '1px solid #e0e0e0',
        borderRadius: '4px',
    },
    '& .Mui-focused': {
        borderColor: '#673ab7',
    },
    '& .MuiFilledInput-root.Mui-focused': {
        border: '1px solid #673ab7',
    },
}));

// Definition of table columns for the asset allocation table
const tableColumns = [
    { id: 'SgrnNo', label: 'GRN-No', minWidth: 50 },
    { id: 'VendName', label: 'Vendor', minWidth: 50 },
    { id: 'BillDt', label: 'Date', minWidth: 50 },
    { id: 'BillNo', label: 'BillNo', minWidth: 50 },
    { id: 'ItmName', label: 'Item', minWidth: 50 },
    { id: 'ItmCatName', label: 'CatName', minWidth: 50 },
    { id: 'ItmGrpName', label: 'GrpName', minWidth: 50 },
    { id: 'ItmSubGrpName', label: 'SubGrpName', minWidth: 50 },
    { id: 'BalQty', label: 'BalQty', minWidth: 50 },
    { id: 'Rate', label: 'Rate', minWidth: 50 },
];

// Main component for Asset Allocation
const AssetDetails = () => {
    const [formData, setFormData] = useState({
        PropId: "",
        SgrnNo: "",
        BillDt: moment().format('DD/MM/YYYY'),
        AssetDocDt: moment().format('DD/MM/YYYY HH:mm:ss'),
        BarcodeFlag: "L",
        AssetDocNo: "",
        Rate: "",
        ItmName: "",
        BillNo: "",
        Image: '',
        ImgName: "",
        ModelBrand: "",
        VendName: "",
        Tenure: "",
        CheckInDt: moment().format('DD/MM/YYYY'),
        Qty: "",
        Remark: "",
        Status: "",
        VisitRemark: "",
        CreatedBy: "",
        RelationId: "",
        DepAccLedId: "",
        SgrnNo: "",
        ItmName: "",
        ItemCategory: "",
        ItemGroup: "",
        ItemSubgroup: "",
        ItmGrpName: "",
        SgrnId: "",
        SgrnDt: moment().format('DD/MM/YYYY'),
        ItmId: "",
        Qty: "",
        Rate: "",
        ModelNo: "",
        ModelBrand: "",
        ModelColour: "",
        ModelClass: "",
        ModelOemPartNo: "",
        WarrantyPeriod: "",
        WarrantyUpto: "",
        ExpLife: "",
        MaintFreq: "",
        DepRate: "",
        SerProvName: '',
    });

    const [error, setError] = useState({
        ItmName: false,
        VendName: false,
        BillNo: false,
        CheckInDt: false
    });

    const [currentRecordPosition, setCurrentRecordPosition] = useState({
        current: 0,
        total: 0
    });
    // State for table data and various UI controls
    const [tableData, setTableData] = useState([]);
    const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
    const [areTableButtonsDisabled, setAreTableButtonsDisabled] = useState(true);
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const [internalMode, setInternalMode] = useState("add");
    const [addDisabled, setAddDisabled] = useState(true);
    const [allButtonDisabled, setAllButtonDisabled] = useState(true);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const [fetchedData, setFetchedData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [ledgerOptions, setLedgerOptions] = useState([]);
    const [serviceProviderOptions, setServiceProviderOptions] = useState([]);
    const [isPropertyDropdownDisabled, setIsPropertyDropdownDisabled] = useState(true);
    const navigate = useNavigate();
    const [mode, setMode] = useState('view');
    const location = useLocation();
    const [currentMstAssetId, setCurrentMstAssetId] = useState(null);
    const [currentDetailIds, setCurrentDetailIds] = useState([]);
    const [Status, setStatus] = useState("1");
    const UserId = sessionStorage.getItem('UserId');
    const [Propertydrp, setPropertydrp] = useState([]);
    const [Propertydrpdata, setPropertydrpdata] = useState();
    const [isFormEditable, setIsFormEditable] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedImageName, setSelectedImageName] = useState(null);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const [openBarcodeDialog, setOpenBarcodeDialog] = useState(false);

    // Refs for input focus
    const RateRef = useRef(null);
    const EnqTypeRef = useRef(null);
    const BillNoRef = useRef(null);

    // Initial setup and data fetching
    useEffect(() => {
        if (location.state && location.state?.MstAssetId) {
            setCurrentMstAssetId(location.state.MstAssetId);
            setMode('view');
            setIsFormDisabled(true);
            setAllButtonDisabled(false);
            setAddDisabled(true);
            setAreTableButtonsDisabled(true);
            retrivefetchAssetData(location.state.MstAssetId, "R");
        } else {
            setMode('add');
            setIsFormDisabled(false);
            setIsFormEditable(true);
            setAddDisabled(false);
            setAreTableButtonsDisabled(false);
            setAllButtonDisabled(false);
            setIsPropertyDropdownDisabled(false);
            setCurrentMstAssetId(null);
            setTableData([]);
            setSelectedRowIndex(-1);
            setFormData({
                PropId: Propertydrp.length > 0 ? Propertydrp[0].Id : "",
                SgrnId: "",
                SgrnDt: moment().format('DD/MM/YYYY'),
                AssetDocDt: moment().format('DD/MM/YYYY'),
                ItmId: "",
                BarcodeFlag: 'L',
                Qty: "",
                Rate: "",
                ImgName: "",
                ModelNo: "",
                ModelBrand: "",
                ModelColour: "",
                ModelClass: "",
                ModelOemPartNo: "",
                WarrantyPeriod: "",
                WarrantyUpto: "",
                ExpLife: "",
                MaintFreq: "",
                DepAccLedId: ledgerOptions.length > 0 ? ledgerOptions[0].Id : "",
                DepRate: "",
                Remark: "",
                Status: "1",
                RelationId: serviceProviderOptions.length > 0 ? serviceProviderOptions[0].Id : "",
            });
            setSelectedImage(null);
            setSelectedImageName(null);
        }
        fetchPropertyData();
        fetchLedgerData();
        fetchServiceProviderData();
    }, [location]);

    // Update form data when a table row is selected
    useEffect(() => {
        if (selectedRowIndex >= 0 && tableData.length > 0) {
            const selectedRow = tableData[selectedRowIndex];
            setFormData({
                ...formData,
                SgrnNo: selectedRow.SgrnNo || "",
                VendName: selectedRow.VendName || "",
                BillDt: selectedRow.BillDt || moment().format('DD/MM/YYYY'),
                BillNo: selectedRow.BillNo || "",
                ItmName: selectedRow.ItmName || "",
                Qty: selectedRow.Qty || "",
                Rate: selectedRow.Rate || "",
                ModelBrand: selectedRow.ModelBrand || "",
                Tenure: selectedRow.WarrantyPeriod || "",
            });
            setAllButtonDisabled(false);
            setAddDisabled(false);
        }
    }, [selectedRowIndex]);

    // Fetch property dropdown data
    const fetchPropertyData = async () => {
        try {
            const response = await axios.post(
                `PropertyMst/GetPropertyMstUserwisedrp`,
                {
                    UserId,
                    Flag: ""
                }
            );
            const manipulateResponse = (response) => response.data.Status === 0;
            if (manipulateResponse(response)) {
                setPropertydrp(response.data.Data);

                if (response.data.Data && response.data.Data.length > 0) {
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        PropId: response.data.Data[0].Id
                    }));
                }
            } else {
                toast.error('Error fetching Property data');
            }
        } catch (error) {
            toast.error('Error fetching Property data');
        }
    };

    // Placeholder for fetching asset data
    const fetchAssetData = async (MstAssetId, flag) => {
        try {
            const response = await axios.post('MstAsset/RetriveMstAsset', {
                MstAssetId: MstAssetId,
                Flag: flag,
                ActionBy: UserId || 0
            });
            if (response.data && response.data.Data && response.data.Data.MstAssetList) {
                const assetData = response.data.Data.MstAssetList[0];
                setTableData([{
                    ...assetData,
                    DBFLAG: "R"
                }]);
                setSelectedRowIndex(0);
            } else {
                toast.error("No data found for this asset");
            }
        } catch (error) {
            toast.error("Error fetching asset data");
        }
    };

    const fetchLedgerData = async () => {
        try {
            const response = await axios.post(`AccLed/GetAccLedDrp`);
            if (response.data && response.data.Data) {
                const mappedLedgerData = response.data.Data.map(item => ({
                    Id: item.AccLedId,
                    Name: item.AccLedName
                }));
                setLedgerOptions(mappedLedgerData);
            } else {
                toast.error('Invalid ledger data format received');
            }
        } catch (error) {
            toast.error('Error fetching ledger data');
        }
    };

    const fetchServiceProviderData = async () => {
        try {
            const response = await axios.post(
                `PartyMst/getPartyMstdrp`,
                {
                    PartyCat: "SP"
                }
            );
            if (response.data && response.data.Data) {
                const mappedData = response.data.Data.map(item => ({
                    Id: item.PartyId || item.Id,
                    Name: item.PartyName || item.Name
                }));
                setServiceProviderOptions(mappedData);
            } else {
                toast.error('Invalid service provider data format received');
            }
        } catch (error) {
            toast.error('Error fetching service provider data');
        }
    };

    const fetchDialogData = async () => {
        try {
            const response = await axios.post('MstAsset/GetSelectMstAssetAll', {
                MstAssetId: "",
                Flag: "S",
                PropId: formData.PropId,
            });

            if (response.data && Array.isArray(response.data.Data)) {
                const mappedData = response.data.Data.map((item, index) => ({
                    MstAssetId: item.MstAssetId || null,
                    MstAssetDtlId: item.MstAssetDtlId || null,
                    SgrnId: item.SgrnId || 0,
                    SgrnNo: item.SgrnNo || "",
                    SgrnItmId: item.SgrnItmId,
                    ItmId: item.ItmId || 0,
                    ItmName: item.ItmName || "",
                    SgrnDt: item.SgrnDt ? moment(item.SgrnDt).format('DD/MM/YYYY') : "",
                    VendId: item.VendId || 0,
                    VendDtlId: item.VendDtlId || 0,
                    VendName: item.VendName || "",
                    ActVendId: item.ActVendId || 0,
                    ActVendDtlId: item.ActVendDtlId || 0,
                    BillNo: item.BillNo || "",
                    BillDt: item.BillDt ? moment(item.BillDt).format('DD/MM/YYYY') : "",
                    ModelBrand: item.ModelBrand || "",
                    ModelNo: item.ModelNo || "",
                    ModelColour: item.ModelColour || "",
                    ModelClass: item.ModelClass || "",
                    ModelOemPartNo: item.ModelOemPartNo || "",
                    Qty: item.Qty || 0,
                    Rate: item.Rate || 0,
                    BalQty: item.BalQty || 0,
                    ExpLife: item.ExpLife || 0,
                    DepAccLedId: item.DepAccLedId || 0,
                    DepRate: item.DepRate || 0,
                    WarrantyPeriod: item.WarrantyPeriod || 0,
                    ItmCatName: item.ItmCatName || 0,
                    ItmGrpName: item.ItmGrpName || 0,
                    ItmSubGrpName: item.ItmSubGrpName || 0,
                    WarrantyUpto: item.WarrantyUpto || 0,
                    MaintFreq: item.MaintFreq || 0,
                    SerProvId: item.SerProvId || 0,
                    SerProvDtlId: item.SerProvDtlId || 0,
                    Remark: item.Remark || "",
                    Status: item.Status || "1",
                    CreatedBy: item.UserId || parseInt(UserId) || 0,
                    DBFLAG: "I"
                }));

                setFetchedData(mappedData);
                if (mappedData.length > 0) {
                    setFormData(prev => ({
                        ...prev,
                        BalQty: mappedData[0].BalQty,
                        Qty: mappedData[0].Qty
                    }));
                }
            } else {
                setFetchedData([]);
                toast.warn("No record found for this property.");
            }
        } catch (error) {
            setFetchedData([]);
            toast.error(`Error fetching data: ${error.message || 'Unknown error'}`);
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        let optionValue = value;

        // Handle Autocomplete or other components that pass an object
        if (event.target.option && event.target.option.Id) {
            optionValue = event.target.option.Id;
        }

        // Ensure BarcodeFlag is updated correctly for radio buttons
        if (name === 'BarcodeFlag') {
            optionValue = value;
        }

        setFormData({
            ...formData,
            [name]: optionValue,
        });

        if (name === 'PropId') {
            setPropertydrpdata(optionValue);
        }
    };

    const handleRowClick = (index) => {
        setSelectedRowIndex(index);
        const selectedRow = tableData[index];
        setFormData(prev => ({
            ...prev,
            SgrnId: selectedRow.SgrnId || "",
            SgrnDt: selectedRow.SgrnDt || moment().format('DD/MM/YYYY'),
            ItmId: selectedRow.ItmId || "",
            Qty: selectedRow.Qty || "",
            Rate: selectedRow.Rate || "",
            ModelNo: selectedRow.ModelNo || "",
            ModelBrand: selectedRow.ModelBrand || "",
            ModelColour: selectedRow.ModelColour || "",
            ModelClass: selectedRow.ModelClass || "",
            ModelOemPartNo: selectedRow.ModelOemPartNo || "",
            WarrantyPeriod: selectedRow.WarrantyPeriod || "",
            WarrantyUpto: selectedRow.WarrantyUpto || "",
            ExpLife: selectedRow.ExpLife || "",
            RelationId: selectedRow.SerProvId || "",
            MaintFreq: selectedRow.MaintFreq || "",
            DepAccLedId: selectedRow.DepAccLedId || "",
            DepRate: selectedRow.DepRate || "",
            Remark: selectedRow.Remark || "",
            Status: selectedRow.Status || "1",
            ItmCatName: selectedRow.ItmCatName || 0,
            ItmGrpName: selectedRow.ItmGrpName || 0,
            ItmSubGrpName: selectedRow.ItmSubGrpName || 0,
        }));
        setAllButtonDisabled(false);
        setAddDisabled(false);
    };

    const handleClickAdd = () => {
        if (!formData.PropId) {
            toast.error("Please select a property first");
            return;
        }

        setInternalMode("add");
        fetchDialogData();
        setOpenDialog(true);
    };

    const handleClickEdit = () => {
        if (selectedRowIndex >= 0) {
            setInternalMode("edit");
            setMode('edit');
            setIsFormEditable(true);
            setIsFormDisabled(false);
            setAddDisabled(true);
            setAllButtonDisabled(true);

            const selectedRow = tableData[selectedRowIndex];
            setFormData(prev => ({
                ...prev,
                SgrnId: selectedRow.SgrnId || "",
                SgrnDt: selectedRow.SgrnDt || moment().format('DD/MM/YYYY'),
                ItmId: selectedRow.ItmId || "",
                Qty: selectedRow.Qty || "",
                Rate: selectedRow.Rate || "",
                ModelNo: selectedRow.ModelNo || "",
                ModelBrand: selectedRow.ModelBrand || "",
                ModelColour: selectedRow.ModelColour || "",
                ModelClass: selectedRow.ModelClass || "",
                ModelOemPartNo: selectedRow.ModelOemPartNo || "",
                WarrantyPeriod: selectedRow.WarrantyPeriod || "",
                WarrantyUpto: selectedRow.WarrantyUpto || "",
                ExpLife: selectedRow.ExpLife || "",
                RelationId: selectedRow.SerProvId || "",
                MaintFreq: selectedRow.MaintFreq || "",
                DepAccLedId: selectedRow.DepAccLedId || "",
                DepRate: selectedRow.DepRate || "",
                Remark: selectedRow.Remark || "",
                Status: selectedRow.Status || "1",
                ItmCatName: selectedRow.ItmCatName || 0,
                ItmGrpName: selectedRow.ItmGrpName || 0,
                ItmSubGrpName: selectedRow.ItmSubGrpName || 0,
                BarcodeFlag: selectedRow.BarcodeFlag || "L",
                ImgName: selectedRow.ImgName || "",
            }));
            setSelectedImage(selectedRow.ImgName || null);
            setSelectedImageName(selectedRow.ImgName ? selectedRow.ImgName.split('/').pop() : null);
        } else {
            toast.error("Please select a row to edit.");
        }
    };

    const handleDelete = () => {
        if (!currentMstAssetId) {
            toast.error("No asset selected to delete");
            return;
        }
        setOpenDeleteDialog(true);
    };

    const handleConfirmDelete = async () => {
        if (!currentMstAssetId) {
            toast.error("No asset selected to delete");
            setOpenDeleteDialog(false);
            return;
        }
        try {
            // Lock the record before deletion
            const flag = await checkAndLock(currentMstAssetId, "MstAsset", "MstAssetId");
            switch (flag) {
                case 0:
                    await retrivefetchAssetData(currentMstAssetId, "D");
                    await retrivefetchAssetData(currentMstAssetId, "N");
                    setMode('view');
                    setIsFormDisabled(true);
                    setIsFormEditable(false);
                    setAddDisabled(false);
                    setAllButtonDisabled(false);
                    setIsPropertyDropdownDisabled(true);
                    setOpenDeleteDialog(false);
                    break;
                case 1:
                    toast.info("Record Already Locked", { autoClose: 500 });
                    setOpenDeleteDialog(false);
                    break;
                case 2:
                    toast.error("Record Failed To Lock", { autoClose: 500 });
                    setOpenDeleteDialog(false);
                    break;
                default:
                    toast.error("Something Went Wrong", { autoClose: 500 });
                    setOpenDeleteDialog(false);
            }
        } catch (error) {
            toast.error("Error deleting asset");
            setOpenDeleteDialog(false);
        }
    };

    const handleCheckboxChange = (event, row) => {
        if (event.target.checked) {
            setSelectedRows([row]);
        } else {
            setSelectedRows([]);
        }
    };

    const [columnFilters, setColumnFilters] = useState(
        tableColumns.reduce((acc, column) => {
            acc[column.id] = '';
            return acc;
        }, {})
    );

    const handleFilterChange = (columnId, value) => {
        setColumnFilters(prev => ({
            ...prev,
            [columnId]: value
        }));
    };

    const filteredData = fetchedData.filter(row =>
        tableColumns.every(column => {
            const filterValue = columnFilters[column.id].toLowerCase();
            if (!filterValue) return true;
            const cellValue = String(row[column.id] || '').toLowerCase();
            return cellValue.includes(filterValue);
        })
    );

    const handleConfirmSelection = () => {
        if (selectedRows.length === 0) {
            toast.error("Please select at least one record.");
            return;
        }
        if (tableData.length > 0 && tableData.some(row => row.DBFLAG !== "D")) {
            toast.error("You can only add one item at a time. Please delete the existing item first.");
            return;
        }
        if (selectedRows.length > 1) {
            toast.error("You can only select one item at a time.");
            return;
        }

        const selectedRow = selectedRows[0];
        const newTableData = [...tableData];

        if (!newTableData.some((existingRow) => existingRow.ItmId === selectedRow.ItmId && existingRow.DBFLAG !== "D")) {
            const newRow = {
                SgrnNo: selectedRow.SgrnNo || "",
                SgrnId: selectedRow.SgrnId || "",
                SgrnItmId: selectedRow.SgrnItmId,
                SgrnDt: selectedRow.SgrnDt || "",
                ItmId: selectedRow.ItmId || "",
                ItmName: selectedRow.ItmName || "",
                VendId: selectedRow.VendId || "",
                VendName: selectedRow.VendName || "",
                BillNo: selectedRow.BillNo || "",
                BillDt: selectedRow.BillDt || "",
                Qty: selectedRow.Qty || "1",
                Rate: selectedRow.Rate || "0",
                ModelNo: selectedRow.ModelNo || "",
                ModelBrand: selectedRow.ModelBrand || "",
                ModelColour: selectedRow.ModelColour || "",
                ModelClass: selectedRow.ModelClass || "",
                ModelOemPartNo: selectedRow.ModelOemPartNo || "",
                WarrantyPeriod: selectedRow.WarrantyPeriod || "",
                WarrantyUpto: selectedRow.WarrantyUpto || "",
                ExpLife: selectedRow.ExpLife || "",
                RelationId: selectedRow.SerProvId || "",
                MaintFreq: selectedRow.MaintFreq || "",
                DepAccLedId: selectedRow.DepAccLedId || "",
                DepRate: selectedRow.DepRate || "",
                Remark: selectedRow.Remark || "",
                Status: selectedRow.Status || "1",
                ItmCatName: selectedRow.ItmCatName || "",
                ItmGrpName: selectedRow.ItmGrpName || "",
                ItmSubGrpName: selectedRow.ItmSubGrpName || "",
                BalQty: selectedRow.BalQty || selectedRow.Qty,
                DBFLAG: 'I',
                BarcodeFlag: formData.BarcodeFlag || "L",
            };

            newTableData.push(newRow);
            setTableData(newTableData);

            setFormData({
                ...formData,
                SgrnId: selectedRow.SgrnId || "",
                SgrnItmId: selectedRow.SgrnItmId,
                SgrnDt: selectedRow.SgrnDt || moment().format('DD/MM/YYYY'),
                ItmId: selectedRow.ItmId || "",
                ItmName: selectedRow.ItmName || "",
                Qty: selectedRow.Qty || "1",
                Rate: selectedRow.Rate || "0",
                ModelNo: selectedRow.ModelNo || "",
                ModelBrand: selectedRow.ModelBrand || "",
                ModelColour: selectedRow.ModelColour || "",
                ModelClass: selectedRow.ModelClass || "",
                ModelOemPartNo: selectedRow.ModelOemPartNo || "",
                WarrantyPeriod: selectedRow.WarrantyPeriod || "",
                WarrantyUpto: selectedRow.WarrantyUpto || "",
                ExpLife: selectedRow.ExpLife || "",
                RelationId: selectedRow.SerProvId || "",
                MaintFreq: selectedRow.MaintFreq || "",
                DepAccLedId: selectedRow.DepAccLedId || "",
                DepRate: selectedRow.DepRate || "",
                Remark: selectedRow.Remark || "",
                Status: selectedRow.Status || "1",
                ItmCatName: selectedRow.ItmCatName || "",
                ItmGrpName: selectedRow.ItmGrpName || "",
                ItmSubGrpName: selectedRow.ItmSubGrpName || "",
                BarcodeFlag: formData.BarcodeFlag || "L",
            });

            setInternalMode("edit");
            setIsFormEditable(true);
            setIsFormDisabled(false);
            setSelectedRowIndex(newTableData.length - 1);
        } else {
            toast.warning(`Item ${selectedRow.ItmName} is already added.`);
            setInternalMode("edit");
            setIsFormEditable(true);
            setIsFormDisabled(false);
            setSelectedRowIndex(newTableData.findIndex(row => row.ItmId === selectedRow.ItmId && row.DBFLAG !== "D"));
        }

        setOpenDialog(false);
        setSelectedRows([]);
        setAddDisabled(true);
        setAllButtonDisabled(false);
    };

    const retrivefetchAssetData = async (MstAssetId, flag) => {
        try {
            const UserId = sessionStorage.getItem('UserId');
            const response = await axiosInstance.post(
                'MstAsset/RetriveMstAsset',
                {
                    MstAssetId: MstAssetId,
                    Flag: flag,
                    ActionBy: UserId || 0
                }
            );

            if (flag === 'D') {
                if (response.data?.Status === 1 || response.data?.Message?.includes("Success")) {
                    toast.success(response.data.Message || "Asset deleted successfully", { autoClose: 500 });
                } else {
                    toast.error(response.data?.Message || "Failed to delete the record");
                }
                return;
            }

            if (response.data && response.data.Data && response.data.Data.MstAssetList) {
                const assetData = response.data.Data.MstAssetList[0];

                setCurrentMstAssetId(assetData.MstAssetId);
                setPropertydrpdata(assetData.PropId);
                setAreTableButtonsDisabled(true);
                setAddDisabled(false);
                setIsPropertyDropdownDisabled(true);
                setAllButtonDisabled(false);

                if (assetData.MstAssetDtlList) {
                    setCurrentDetailIds(assetData.MstAssetDtlList.map(detail => detail.MstAssetDtlId));
                } else {
                    setCurrentDetailIds([]);
                }

                if (response.data?.Data?.Position) {
                    setCurrentRecordPosition({
                        current: response.data.Data.Position.Current,
                        total: response.data.Data.Position.Total
                    });
                }

                const fixedImageUrl = assetData.ImgName?.replace(/^http:\//, 'http://');
                setFormData({
                    ...formData,
                    PropId: assetData.PropId || "",
                    SgrnNo: assetData.SgrnNo || "",
                    SgrnId: assetData.SgrnId || "",
                    SgrnDt: assetData.SgrnDt ? moment(assetData.SgrnDt).format('DD/MM/YYYY') : "",
                    AssetDocDt: assetData.AssetDocDt ? moment(assetData.AssetDocDt).format('DD/MM/YYYY') : "",
                    AssetDocNo: assetData.AssetDocNo || "",
                    BarcodeFlag: assetData.BarcodeFlag || "L",
                    ItmId: assetData.ItmId || "",
                    ItmName: assetData.ItmName || "",
                    Qty: assetData.Qty || "",
                    BalQty: assetData.BalQty || "",
                    Rate: assetData.Rate || "",
                    ModelNo: assetData.ModelNo || "",
                    ModelBrand: assetData.ModelBrand || "",
                    ModelColour: assetData.ModelColour || "",
                    ModelClass: assetData.ModelClass || "",
                    ModelOemPartNo: assetData.ModelOemPartNo || "",
                    WarrantyPeriod: assetData.WarrantyPeriod || "",
                    WarrantyUpto: assetData.WarrantyUpto || "",
                    ExpLife: assetData.ExpLife || "",
                    RelationId: assetData.SerProvId || "",
                    MaintFreq: assetData.MaintFreq || "",
                    DepAccLedId: assetData.DepAccLedId || "",
                    DepRate: assetData.DepRate || "",
                    Remark: assetData.Remark || "",
                    ItmCatName: assetData.ItmCatName || "",
                    ItmGrpName: assetData.ItmGrpName || "",
                    ItmSubGrpName: assetData.ItmSubGrpName || "",
                    Status: assetData.Status || "1",
                    ImgName: fixedImageUrl || '',
                    SerProvName: assetData.SerProvName || "",
                    SerProvDtlName: assetData.SerProvDtlName || "",
                });

                setSelectedImage(fixedImageUrl || '');
                const tableRow = {
                    PropId: assetData.PropId,
                    MstAssetId: assetData.MstAssetId,
                    MstAssetDtlId: assetData.MstAssetDtlId,
                    SgrnId: assetData.SgrnId,
                    SgrnNo: assetData.SgrnNo,
                    SgrnItmId: assetData.SgrnItmId,
                    ItmId: assetData.ItmId,
                    ItmName: assetData.ItmName,
                    SgrnDt: assetData.SgrnDt ? moment(assetData.SgrnDt).format('DD/MM/YYYY') : "",
                    AssetDocDt: assetData.AssetDocDt ? moment(assetData.AssetDocDt).format('DD/MM/YYYY') : "",
                    VendId: assetData.VendId,
                    VendDtlId: assetData.VendDtlId,
                    VendName: assetData.VendName,
                    ActVendId: assetData.ActVendId,
                    ActVendDtlId: assetData.ActVendDtlId,
                    BillNo: assetData.BillNo,
                    BillDt: assetData.BillDt ? moment(assetData.BillDt).format('DD/MM/YYYY') : "",
                    ModelBrand: assetData.ModelBrand,
                    ModelNo: assetData.ModelNo || "",
                    ModelColour: assetData.ModelColour,
                    ModelClass: assetData.ModelClass,
                    ModelOemPartNo: assetData.ModelOemPartNo || "",
                    Qty: assetData.Qty,
                    Rate: assetData.Rate,
                    BalQty: assetData.BalQty,
                    ExpLife: assetData.ExpLife,
                    DepAccLedId: assetData.DepAccLedId,
                    DepRate: assetData.DepRate,
                    WarrantyPeriod: assetData.WarrantyPeriod,
                    WarrantyUpto: assetData.WarrantyUpto,
                    MaintFreq: assetData.MaintFreq,
                    RelationId: assetData.SerProvId || "",
                    Remark: assetData.Remark,
                    Status: assetData.Status,
                    DBFLAG: "R",
                    SerProvId: assetData.SerProvId || 0,
                    SerProvDtlId: assetData.SerProvDtlId || 0,
                    ItmCatName: assetData.ItmCatName || "",
                    ItmGrpName: assetData.ItmGrpName || "",
                    ItmSubGrpName: assetData.ItmSubGrpName || "",
                    BarcodeFlag: assetData.BarcodeFlag || "L",
                    ImgName: fixedImageUrl || '',
                };

                setSelectedImage(fixedImageUrl || '');
                setTableData([tableRow]);
                setSelectedRowIndex(0);
                setMode('view');
                setIsFormDisabled(true);
            } else {
                toast.info(response.data?.Message || "No more records available");
                setFormData({
                    PropId: Propertydrp.length > 0 ? Propertydrp[0].Id : "",
                    SgrnId: "",
                    SgrnDt: moment().format('DD/MM/YYYY'),
                    AssetDocDt: moment().format('DD/MM/YYYY'),
                    ItmId: "",
                    BarcodeFlag: 'L',
                    Qty: "",
                    Rate: "",
                    ImgName: "",
                    ModelNo: "",
                    ModelBrand: "",
                    ModelColour: "",
                    ModelClass: "",
                    ModelOemPartNo: "",
                    WarrantyPeriod: "",
                    WarrantyUpto: "",
                    ExpLife: "",
                    RelationId: serviceProviderOptions.length > 0 ? serviceProviderOptions[0].Id : "",
                    MaintFreq: "",
                    DepAccLedId: ledgerOptions.length > 0 ? ledgerOptions[0].Id : "",
                    DepRate: "",
                    Remark: "",
                    Status: "1",
                });
                setSelectedImage(null);
                setSelectedImageName(null);
                setTableData([]);
                setCurrentMstAssetId(null);
                setSelectedRowIndex(-1);
                setMode('view');
                setIsFormDisabled(true);
                setIsFormEditable(false);
                setAddDisabled(false);
                setAllButtonDisabled(false);
                setIsPropertyDropdownDisabled(true);
            }
        } catch (error) {
            toast.error("Error fetching asset data");
        }
    };

    useEffect(() => {
        if (location.state && location.state.MstAssetId) {
            setCurrentMstAssetId(location.state.MstAssetId);
            setMode('view');
            setIsFormDisabled(true);
            retrivefetchAssetData(location.state.MstAssetId, "R");
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
        fetchPropertyData();
        fetchLedgerData();
        fetchServiceProviderData();
    }, [location]);

    const handlePrevious = async () => {
        if (currentMstAssetId) {
            try {
                await retrivefetchAssetData(currentMstAssetId, "P");
            } catch (error) {
                toast.error("Failed to fetch previous record");
            }
        } else {
            toast.error("No current asset selected");
        }
    };

    const handleNext = async () => {
        if (currentMstAssetId) {
            try {
                await retrivefetchAssetData(currentMstAssetId, "N");
            } catch (error) {
                toast.error("Failed to fetch next record");
            }
        } else {
            toast.error("No current asset selected");
        }
    };

    const handlePrintBarcode = () => {
        if (!currentMstAssetId || selectedRowIndex < 0 || !tableData[selectedRowIndex]) {
            toast.error("No asset selected to print barcode");
            return;
        }
        setOpenBarcodeDialog(true);
    };

    const handleCloseBarcodeDialog = () => {
        setOpenBarcodeDialog(false);
    };

    const handleSubmit = async () => {
        try {
            if (tableData.length === 0) {
                toast.error("Please add at least one asset item");
                return;
            }
            const selectedRow = tableData[selectedRowIndex >= 0 ? selectedRowIndex : 0];
            const payload = [{
                DBFLAG: mode === 'add' ? "I" : "U",
                MstAssetId: mode === 'edit' ? parseInt(currentMstAssetId) || 0 : undefined,
                PropId: parseInt(formData.PropId) || 1,
                SgrnId: parseInt(selectedRow.SgrnId) || 1,
                SgrnItmId: parseInt(selectedRow.SgrnItmId),
                ItmId: parseInt(selectedRow.ItmId) || 1,
                SgrnDt: selectedRow.SgrnDt ? moment(selectedRow.SgrnDt, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : null,
                AssetDocDt: formData.AssetDocDt ? moment(formData.AssetDocDt, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss') : null,
                AssetDocNo: formData.AssetDocNo || "",
                BarcodeFlag: formData.BarcodeFlag || "L",
                VendId: parseInt(selectedRow.VendId) || 1,
                VendDtlId: parseInt(selectedRow.VendDtlId) || 1,
                ActVendId: parseInt(selectedRow.ActVendId) || parseInt(selectedRow.VendId) || 1,
                ActVendDtlId: parseInt(selectedRow.ActVendDtlId) || parseInt(selectedRow.VendDtlId) || 1,
                BillNo: selectedRow.BillNo || "",
                BillDt: selectedRow.BillDt ? moment(selectedRow.BillDt, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : null,
                ModelBrand: formData.ModelBrand || "",
                ModelNo: formData.ModelNo || "",
                ModelColour: formData.ModelColour || "",
                ModelClass: formData.ModelClass || "",
                ModelOemPartNo: formData.ModelOemPartNo || "",
                Qty: parseFloat(selectedRow.Qty) || 0,
                Rate: parseFloat(selectedRow.Rate) || 0,
                BalQty: parseFloat(selectedRow.BalQty) || parseFloat(selectedRow.Qty) || 0,
                ExpLife: formData.ExpLife ? parseInt(formData.ExpLife) : 0,
                DepAccLedId: parseInt(formData.DepAccLedId) || 1,
                DepRate: formData.DepRate ? parseFloat(formData.DepRate) : 0,
                WarrantyPeriod: formData.WarrantyPeriod ? parseInt(formData.WarrantyPeriod) : 0,
                WarrantyUpto: formData.WarrantyUpto ? parseInt(formData.WarrantyUpto) : 0,
                MaintFreq: formData.MaintFreq ? parseInt(formData.MaintFreq) : 0,
                Image: selectedImage || "",
                ImgName: selectedImageName || "",
                SerProvId: parseInt(formData.RelationId) || parseInt(selectedRow.SerProvId) || 1,
                SerProvDtlId: parseInt(selectedRow.SerProvDtlId) || 1,
                Remark: formData.Remark || "",
                Status: selectedRow.Status || "1",
                CreatedBy: parseInt(UserId),
                UpdatedBy: parseInt(UserId),
            }];

            const response = await axiosInstance.post('MstAsset/ManageMstAssetItm', payload);

            if (response.data?.Message?.includes("Successfully") || response.data?.Status === 1) {
                if (payload[0].DBFLAG === "I") {
                    toast.success(response.data.Message || "Asset data saved successfully");
                } else if (payload[0].DBFLAG === "U") {
                    toast.success("Data updated successfully");
                }
                const insertedMstAssetId = response.data.Data?.[0]?.MstAssetId || currentMstAssetId;
                // Set form to view mode and enable CRUD buttons
                setMode('view');
                setIsFormDisabled(true);
                setIsFormEditable(false);
                setAddDisabled(true);
                setAllButtonDisabled(false);
                setAreTableButtonsDisabled(false);
                setIsPropertyDropdownDisabled(true);

                if (insertedMstAssetId) {
                    setCurrentMstAssetId(insertedMstAssetId);
                    await retrivefetchAssetData(insertedMstAssetId, "R");
                }
            } else {
                const errorMsg = response.data?.Message || "Failed to save asset data";
                toast.error(errorMsg);
            }
        } catch (error) {
            toast.error(`Error submitting asset data: ${error.message || 'Unknown error'}`);
        }
    };

    const handleAdd = () => {
        setMode('add');
        setInternalMode('add');
        setCurrentMstAssetId(null);
        setIsFormDisabled(false);
        setIsFormEditable(true);
        setAddDisabled(false);
        setAllButtonDisabled(true);
        setAreTableButtonsDisabled(false);
        setSelectedRowIndex(-1);
        setIsPropertyDropdownDisabled(false);
        setAreTableButtonsDisabled(false);
        const firstProperty = Propertydrp.length > 0 ? Propertydrp[0] : null;
        const firstService = serviceProviderOptions.length > 0 ? serviceProviderOptions[0] : null;
        const firstLedger = ledgerOptions.length > 0 ? ledgerOptions[0] : null;
        setFormData({
            PropId: firstProperty ? firstProperty.Id : "",
            SgrnId: "",
            SgrnDt: moment().format('DD/MM/YYYY'),
            AssetDocDt: moment().format('DD/MM/YYYY'),
            ItmId: "",
            BarcodeFlag: 'L',
            Qty: "",
            Rate: "",
            ImgName: "",
            ModelNo: "",
            ModelBrand: "",
            ModelColour: "",
            ModelClass: "",
            ModelOemPartNo: "",
            WarrantyPeriod: "",
            WarrantyUpto: "",
            ExpLife: "",
            RelationId: firstService ? firstService.Id : "",
            MaintFreq: "",
            DepAccLedId: firstLedger ? firstLedger.Id : "",
            DepRate: "",
            Remark: "",
            Status: "1",
        });
        setSelectedImage(null);
        setSelectedImageName(null);
        setTableData([]);
    };

    const handleEdit = () => {
        setMode('edit');
        setInternalMode('edit');
        setIsFormDisabled(false);
        setAddDisabled(false);
        setAllButtonDisabled(false);
    };

    const handleCancel = () => {
        if (currentMstAssetId) {
            setMode('view');
            setInternalMode('view');
            setIsFormDisabled(true);
            fetchAssetData(currentMstAssetId, "R");
        } else {
            setMode('view');
            setInternalMode('view');
            setIsFormDisabled(true);
            setFormData({
                PropId: Propertydrp.length > 0 ? Propertydrp[0].Id : "",
                SgrnId: "",
                SgrnDt: moment().format('DD/MM/YYYY'),
                AssetDocDt: moment().format('DD/MM/YYYY'),
                ItmId: "",
                Qty: "",
                Rate: "",
                ModelNo: "",
                ModelBrand: "",
                ModelColour: "",
                ModelClass: "",
                ModelOemPartNo: "",
                WarrantyPeriod: "",
                WarrantyUpto: "",
                ExpLife: "",
                RelationId: "",
                MaintFreq: "",
                DepAccLedId: "",
                DepRate: "",
                Remark: "",
                Status: "1"
            });
            setTableData([]);
        }
        setSelectedRowIndex(-1);
        setAddDisabled(true);
        setAllButtonDisabled(false);
        setIsFormEditable(false);
    };

    const handleExit = () => {
        navigate('/assetdetailstable');
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            handleImageUpload(file);
        } else {
            setSelectedImage(null);
            setSelectedImageName(null);
        }
    };
    // Uplaoding the image file
    const handleImageUpload = (file) => {
        if (!file) return;
        setSelectedImageName(file.name);
        const reader = new FileReader();
        reader.onload = function (e) {
            setSelectedImage(e.target.result);
        };
        reader.readAsDataURL(file);
    };

    const handleChangeStatus = (event) => {
        setStatus(event.target.checked ? "1" : "0");
    };

    return (
        <>
            <ToastContainer />
            <Box className="form-container">
                <Grid container spacing={2} className="form_grid">
                    <Grid item xs={12} className="form_title"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginTop: "20px",
                            flexDirection: { xs: "column", sm: "row", md: "row" },
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 },
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-previous"
                                onClick={handlePrevious}
                                disabled={allButtonDisabled}
                                sx={{
                                    backgroundColor: '#635BFF',
                                    marginRight: { xs: '5px', sm: '10px' },
                                    display: 'block',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#d3d3d3',
                                    }
                                }}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>
                            <Button
                                variant="contained"
                                size="small"
                                className="three-d-button-next"
                                onClick={handleNext}
                                disabled={allButtonDisabled}
                                sx={{
                                    backgroundColor: '#635BFF',
                                    display: 'block',
                                    '&.Mui-disabled': {
                                        backgroundColor: '#d3d3d3',
                                    }
                                }}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            flexGrow: 1,
                            justifyContent: 'center',
                            flexDirection: { xs: 'column', sm: 'row' }
                        }}>
                            <Typography variant="h5" sx={{
                                textAlign: "center",
                                fontSize: { xs: "24px", sm: "18px", md: "24px" },
                                whiteSpace: 'nowrap',
                            }}>
                                Asset Details
                            </Typography>
                        </Box>

                        <Grid sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            gap: "10px",
                            flexWrap: "wrap"
                        }}>
                            <CrudButtons
                                moduleName="Asset Details"
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleClickEdit}
                                onView={handlePrint}
                                onDelete={handleDelete}
                                onExit={handleExit}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Paper sx={{ width: "100%", overflow: "hidden", margin: "0px auto 20px auto", border: "1px solid lightgray" }}>
                            <TableContainer sx={{ maxHeight: 300 }}>
                                <Table
                                    stickyHeader
                                    size="small"
                                    sx={{
                                        '& .MuiTableCell-root': {
                                            padding: '1.4px 3px',
                                            lineHeight: '1.2',
                                        },
                                        '& .MuiTableRow-root': {
                                            height: '0px',
                                        }
                                    }}
                                >
                                    <TableHead>
                                        <TableRow>
                                            {tableColumns.map((column) => (
                                                <TableCell
                                                    key={column.id}
                                                    style={{
                                                        minWidth: column.minWidth,
                                                        padding: '0px',
                                                        backgroundColor: '#f5f5f5'
                                                    }}
                                                >
                                                    <Typography variant="subtitle2" fontWeight="bold">{column.label}</Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {tableData.filter(row => row.DBFLAG !== "D").map((row, index) => (
                                            <TableRow
                                                hover
                                                key={index}
                                                onClick={() => handleRowClick(index)}
                                                selected={selectedRowIndex === index}
                                                sx={{
                                                    '&.Mui-selected': {
                                                        backgroundColor: '#e3f2fd',
                                                    },
                                                    '&.Mui-selected:hover': {
                                                        backgroundColor: '#bbdefb',
                                                    }
                                                }}
                                            >
                                                {tableColumns.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        sx={{
                                                            padding: '6px 8px',
                                                            fontSize: '0.85rem'
                                                        }}
                                                    >
                                                        {row[column.id] || "N/A"}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Paper>
                    </Grid>

                    {openDialog && (
                        <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="lg" fullWidth>
                            <DialogTitle>Select Records</DialogTitle>
                            <DialogContent sx={{
                                overflowY: 'auto',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingBottom: '10px'
                            }}>
                                <TableContainer sx={{
                                    maxHeight: '55vh',
                                    width: '100%',
                                    '& .MuiTableCell-root': {
                                        padding: '4px 6px',
                                        lineHeight: '1.1',
                                        fontSize: '0.85rem'
                                    },
                                    '& .MuiTableRow-root': {
                                        height: '2px',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                                        }
                                    }
                                }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow sx={{
                                                '& .MuiTableCell-head': {
                                                    backgroundColor: '#f5f5f5',
                                                    padding: '5px',
                                                    fontWeight: 'bold'
                                                }
                                            }}>
                                                <TableCell align="center" sx={{ width: '50px' }}>Select</TableCell>
                                                {tableColumns.map((column) => (
                                                    <TableCell
                                                        key={column.id}
                                                        align="center"
                                                        sx={{ minWidth: column.minWidth }}
                                                    >
                                                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                                            <Typography variant="subtitle2">{column.label}</Typography>
                                                            <TextField
                                                                size="small"
                                                                variant="outlined"
                                                                value={columnFilters[column.id]}
                                                                onChange={(e) => handleFilterChange(column.id, e.target.value)}
                                                                sx={{
                                                                    marginTop: '4px',
                                                                    '& .MuiInputBase-root': {
                                                                        height: '28px'
                                                                    }
                                                                }}
                                                            />
                                                        </Box>
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {filteredData.map((row, index) => (
                                                <TableRow
                                                    key={`row-${index}`}
                                                    sx={{
                                                        '&.Mui-selected': {
                                                            backgroundColor: '#e3f2fd'
                                                        }
                                                    }}
                                                >
                                                    <TableCell align="center">
                                                        <Checkbox
                                                            size="small"
                                                            checked={selectedRows.some(r => r.SgrnItmId === row.SgrnItmId)}
                                                            onChange={(e) => handleCheckboxChange(e, row)}
                                                            disabled={selectedRows.length > 0 && !selectedRows.some(r => r.SgrnItmId === row.SgrnItmId)}
                                                        />
                                                    </TableCell>
                                                    {tableColumns.map((column) => (
                                                        <TableCell
                                                            key={`${column.id}-${index}`}
                                                            align="center"
                                                        >
                                                            {row[column.id] || "N/A"}
                                                        </TableCell>
                                                    ))}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </DialogContent>
                            <DialogActions sx={{
                                padding: '8px 16px',
                                borderTop: '1px solid #e0e0e0'
                            }}>
                                <Button
                                    onClick={handleConfirmSelection}
                                    color="primary"
                                    size="small"
                                    sx={{ minWidth: '80px' }}
                                    disabled={selectedRows.length === 0}
                                >
                                    Confirm
                                </Button>
                                <Button
                                    onClick={() => {
                                        setOpenDialog(false);
                                        setSelectedRows([]);
                                        setColumnFilters(tableColumns.reduce((acc, column) => {
                                            acc[column.id] = '';
                                            return acc;
                                        }, {}));
                                    }}
                                    color="secondary"
                                    size="small"
                                    sx={{ minWidth: '80px' }}
                                >
                                    Cancel
                                </Button>
                            </DialogActions>
                        </Dialog>
                    )}

                    <Grid item xs={12} className="form_field"
                        sx={{
                            display: 'flex',
                            justifyContent: 'start',
                            marginInline: { xs: "10px", sm: "20px" },
                            marginTop: "0px",
                            paddingTop: "0px",
                        }}
                    >
                        <Box >
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <CustomAutocomplete
                                                options={Propertydrp}
                                                id="PropId-autocomplete"
                                                name='PropId'
                                                label="Property"
                                                value={Propertydrp.find(PropId => PropId.Id == formData.PropId) || (Propertydrp.length > 0 ? Propertydrp[0] : null)}
                                                onChange={handleInputChange}
                                                disabled={isPropertyDropdownDisabled || mode === 'view'}
                                                size="small"
                                                getOptionLabel={(option) => option.Name || ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="MstAssetId"
                                                name="MstAssetId"
                                                label={<span>Asset Id</span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.MstAssetId || (tableData[selectedRowIndex]?.MstAssetId ?? "")}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                error={error.MstAssetId}
                                                helperText={error.MstAssetId ? '' : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="AssetDocNo"
                                                name="AssetDocNo"
                                                label={<span>AssetDocNo</span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.AssetDocNo || (tableData[selectedRowIndex]?.AssetDocNo ?? "")}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                error={error.AssetDocNo}
                                                helperText={error.AssetDocNo ? '' : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={enGB}>
                                                <DatePicker
                                                    label="Entry Date"
                                                    value={formData.AssetDocDt ? new Date(moment(formData.AssetDocDt, 'DD/MM/YYYY HH:mm:ss').toDate()) : new Date()}
                                                    onChange={(newValue) => {
                                                        setFormData((prev) => ({
                                                            ...prev,
                                                            AssetDocDt: newValue && isValid(newValue) ? moment(newValue).format('DD/MM/YYYY HH:mm:ss') : moment().format('DD/MM/YYYY HH:mm:ss'),
                                                        }));
                                                    }}
                                                    disabled={!isFormEditable}
                                                    views={['day', 'month', 'year']}
                                                    openTo="day"
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            fullWidth: true,
                                                            variant: "filled",
                                                            className: "custom-textfield",
                                                            InputLabelProps: { shrink: true },
                                                            error: error.AssetDocDt,
                                                        },
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={1}>
                                            <Button
                                                variant="contained"
                                                onClick={handleClickAdd}
                                                disabled={addDisabled || areTableButtonsDisabled || !formData.PropId}
                                                size="small"
                                                color='primary'
                                                sx={{ backgroundColor: '#635bff', '&:hover': { backgroundColor: '#4a2fdb' }, borderRadius: '18px' }}
                                            >
                                                <AddIcon /> Item
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={2} sx={{ position: 'relative' }}>
                                            <Box sx={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'flex-start',
                                                position: 'relative',
                                            }}>
                                                {!selectedImage ? (
                                                    <>
                                                        <input
                                                            accept="image/*"
                                                            style={{ display: "none" }}
                                                            id="upload-photo"
                                                            type="file"
                                                            onChange={handleImageChange}
                                                            disabled={!isFormEditable}
                                                        />
                                                        <label htmlFor="upload-photo">
                                                            <Button
                                                                component="span"
                                                                variant="contained"
                                                                size="small"
                                                                sx={{
                                                                    backgroundColor: '#635bff',
                                                                    color: 'white',
                                                                    '&:hover': { backgroundColor: '#4a2fdb' },
                                                                    mb: 1,
                                                                    borderRadius: '8px',
                                                                }}
                                                                disabled={!isFormEditable}
                                                                startIcon={<CloudUploadIcon />}
                                                            >
                                                                Upload Image
                                                            </Button>
                                                        </label>
                                                    </>
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        sx={{
                                                            backgroundColor: '#f44336',
                                                            color: 'white',
                                                            '&:hover': { backgroundColor: '#d32f2f' },
                                                            mb: 1,
                                                        }}
                                                        disabled={!isFormEditable}
                                                        onClick={() => {
                                                            setSelectedImage(null);
                                                            setSelectedImageName(null);
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                ImgName: "",
                                                            }));
                                                        }}
                                                        startIcon={<DeleteIcon />}
                                                    >
                                                        Clear Image
                                                    </Button>
                                                )}
                                                {(selectedImage || formData.ImgName) && (
                                                    <Box
                                                        sx={{
                                                            position: 'absolute',
                                                            top: '100%',
                                                            left: '-50px',
                                                            mt: 1,
                                                            zIndex: 10,
                                                            backgroundColor: '#fff',
                                                            border: '1px solid #e0e0e0',
                                                            borderRadius: '4px',
                                                            p: 1,
                                                        }}
                                                    >
                                                        <img
                                                            src={selectedImage || formData.ImgName}
                                                            alt="No Image Uploaded"
                                                            style={{
                                                                maxWidth: '200px',
                                                                maxHeight: '130px',
                                                                objectFit: 'contain'
                                                            }}
                                                        />
                                                    </Box>
                                                )}
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                id="ItmName"
                                                name="ItmName"
                                                label={<span>Item Name</span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ItmName || (tableData[selectedRowIndex]?.ItmName ?? "")}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                error={error.ItmName}
                                                helperText={error.ItmName ? '' : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ItmCatName"
                                                name="ItmCatName"
                                                label={<span>Item Category</span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ItmCatName || (tableData[selectedRowIndex]?.ItmCatName ?? "")}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                error={error.ItmCatName}
                                                helperText={error.ItmCatName ? '' : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ItmGrpName"
                                                name="ItmGrpName"
                                                label={<span>Item Group</span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ItmGrpName || (tableData[selectedRowIndex]?.ItmGrpName ?? "")}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                error={error.ItmGrpName}
                                                helperText={error.ItmGrpName ? '' : ''}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ItmSubGrpName"
                                                name="ItmSubGrpName"
                                                label={<span>Item Subgroup</span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ItmSubGrpName || (tableData[selectedRowIndex]?.ItmSubGrpName ?? "")}
                                                onChange={handleInputChange}
                                                disabled={true}
                                                error={error.ItmSubGrpName}
                                                helperText={error.ItmSubGrpName ? '' : ''}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={2} >
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                id="ModelNo"
                                                name="ModelNo"
                                                label="Model No"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ModelNo}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ModelBrand"
                                                name="ModelBrand"
                                                label="Brand"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ModelBrand}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ModelColour"
                                                name="ModelColour"
                                                label="Color"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ModelColour}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ModelClass"
                                                name="ModelClass"
                                                label="Class"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ModelClass}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                id="ModelOemPartNo"
                                                name="ModelOemPartNo"
                                                label="Oem Part No"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ModelOemPartNo}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="WarrantyPeriod"
                                                name="WarrantyPeriod"
                                                label="Warranty Period"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.WarrantyPeriod}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="WarrantyUpto"
                                                name="WarrantyUpto"
                                                label="Warranty Upto"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.WarrantyUpto}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="ExpLife"
                                                name="ExpLife"
                                                label="Exp Life"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.ExpLife}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={2} >
                                        <Grid item xs={12} sm={6} md={3}>
                                            <CustomAutocomplete
                                                options={ledgerOptions}
                                                id="DepAccLedId-autocomplete"
                                                name="DepAccLedId"
                                                label="Ledger"
                                                value={ledgerOptions.find(option => option.Id === formData.DepAccLedId) || null}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="MaintFreq"
                                                name="MaintFreq"
                                                label="Maintenance Freq"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.MaintFreq}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="DepRate"
                                                name="DepRate"
                                                label="Dep Rate"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.DepRate}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2}>
                                            <TextField
                                                id="Qty"
                                                name="Qty"
                                                label={<span>Quantity <span style={{ color: 'red' }}>*</span></span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.Qty}
                                                onChange={handleInputChange}
                                                disabled={true}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            {!currentMstAssetId &&
                                                <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                                                    <FormLabel
                                                        id="barcode-radio-group-label"
                                                        sx={{
                                                            color: 'black',
                                                            fontSize: '0.95rem',
                                                            fontWeight: 500,
                                                            minWidth: '100px',
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        Barcode Type
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="barcode-radio-group-label"
                                                        name="BarcodeFlag"
                                                        value={formData.BarcodeFlag || "L"}
                                                        onChange={handleInputChange}
                                                    >
                                                        <FormControlLabel
                                                            value="L"
                                                            control={<Radio size="small" disabled={!isFormEditable} />}
                                                            label="Lot"
                                                        />
                                                        <FormControlLabel
                                                            value="U"
                                                            control={<Radio size="small" disabled={!isFormEditable} />}
                                                            label="Unique"
                                                            sx={{ mr: 2 }}
                                                        />
                                                    </RadioGroup>
                                                </Box>
                                            }
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={2} >
                                        <Grid item xs={12} sm={6} md={3}>
                                            <CustomAutocomplete
                                                options={serviceProviderOptions}
                                                id="RelationId-autocomplete"
                                                name='RelationId'
                                                label="Service Provider"
                                                value={serviceProviderOptions.find(option => option.Id === formData.RelationId) || null}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <TextField
                                                id="Remark"
                                                name="Remark"
                                                label="Remark"
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.Remark}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={1}>
                                            <TextField
                                                id="Rate"
                                                name="Rate"
                                                label={<span>Rate <span style={{ color: 'red' }}>*</span></span>}
                                                variant="filled"
                                                fullWidth
                                                className="custom-textfield"
                                                value={formData.Rate}
                                                onChange={handleInputChange}
                                                disabled={!isFormEditable}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '7px' }}>
                                                {currentMstAssetId &&
                                                    <Button
                                                        variant="contained"
                                                        onClick={handlePrintBarcode}
                                                        sx={{
                                                            backgroundColor: '#635bff',
                                                            '&:hover': { backgroundColor: '#4a2fdb' },
                                                            textTransform: 'none',
                                                            borderRadius: '18px',
                                                        }}
                                                    >
                                                        <PrintIcon sx={{ mr: 1 }} />Print Barcode
                                                    </Button>
                                                }
                                                <Dialog
                                                    open={openBarcodeDialog}
                                                    onClose={handleCloseBarcodeDialog}
                                                    maxWidth="lg"
                                                    fullWidth
                                                >
                                                    <DialogContent>
                                                        <PrintBarcode
                                                            handleClose={handleCloseBarcodeDialog}
                                                            MstAssetId={currentMstAssetId}
                                                            MstAssetDtlId={tableData[selectedRowIndex]?.MstAssetDtlId || 1}
                                                        />
                                                    </DialogContent>
                                                </Dialog>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: 'linear-gradient(290deg, #d4d4d4, #ffffff)',
                                        '&.Mui-disabled': {
                                            background: 'linear-gradient(290deg, #d4d4d4, #ffffff)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                        }
                                    }}
                                    onClick={handleSubmit}
                                    disabled
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        background: 'linear-gradient(290deg, #a7c5e9, #ffffff)',
                                        '&.Mui-disabled': {
                                            background: 'linear-gradient(290deg, #a7c5e9, #ffffff)',
                                            color: 'rgba(0, 0, 0, 0.26)'
                                        }
                                    }}
                                    onClick={handleCancel}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        backgroundColor: '#635bff',
                                        '&:hover': { backgroundColor: '#4a2fdb' }
                                    }}
                                    onClick={handleSubmit}
                                >
                                    Submit
                                </Button>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mr: 1,
                                        backgroundColor: '#635bff',
                                        '&:hover': { backgroundColor: '#4a2fdb' }
                                    }}
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: "none" }}>
                <AssetDocumentPrint
                    contentRef={contentRef}
                    formData={formData}
                    propertyList={Propertydrp}
                />
            </div>

            <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>Are you sure you want to delete this record?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={handleConfirmDelete}>Yes</Button>
                    <Button sx={{ backgroundColor: '#635bff', color: 'white', '&:hover': { backgroundColor: '#1565c0' } }} onClick={() => setOpenDeleteDialog(false)}>No</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default AssetDetails;